import * as Clipboard from 'expo-clipboard';
import { useCallback } from 'react';

import { useToaster } from './useToaster';

import { Sentry } from '@/util/sentry';

const useClipboard = () => {
  const toast = useToaster();

  const copyToClipboard = useCallback(
    async (text: string, callback?: () => void, successTitle = 'Copied to clipboard') => {
      try {
        await Clipboard.setStringAsync(text);

        toast.showSuccess({
          title: successTitle,
        });

        if (callback) {
          callback();
        }
      } catch (error) {
        Sentry.captureException(error);

        toast.showError({
          title: 'Failed to copy to clipboard',
        });
      }
    },
    [toast]
  );

  return { copyToClipboard };
};

export default useClipboard;
